// leaveBalancesApi.js
import api from '../api'; // Import your configured axios instance

// GET all leave balances
export const getAllLeaveBalance = async () => {
  const response = await api.get('/leave-balances/');
  return response.data;
};

// GET all leave balances previous and current year combined
export const getAllLeaveBalanceCombined = async () => {
  const response = await api.get('/leave-balances/combined');
  return response.data;
};

export const getAllAnnualLeaveBalancesExcludingInternships = async () => {
  const response = await api.get('/leave-balances/non-internship');
  const data = response.data;

  // 🔒 Normalize to array:
  if (Array.isArray(data)) {
    return data;
  }

  // Common Spring formats like Page<LeaveBalance> or wrapper objects
  if (data && Array.isArray(data.content)) {
    return data.content;
  }
  if (data && Array.isArray(data.items)) {
    return data.items;
  }

  // If backend returns something unexpected (error, string, etc.)
  console.warn('Unexpected leave-balances/non-interns response:', data);
  return [];
};

// GET specific leave balance by ID
export const getLeaveBalance = async (id) => {
  const response = await api.get(`/leave-balances/${id}`);
  return response.data;
};

// GET authenticated Employee leave balance
export const getMyLeaveBalance = async () => {
  const response = await api.get(`/leaves/myBalance`);
  return response.data;
};

// GET authenticated Employee balance details (current year balance, pending balance, approved and pending annual leave days)
export const getMyBalanceDetails = async () => {
  const response = await api.get(`/leave-balances/my-balance-details`);
  return response.data;
};

// Update leave balance
export const updateLeaveBalance = async (id, formData) => {
  const response = await api.put(`/leave-balances/${id}`, formData);
  return response.data;
};

// Update leave balance
export const updatePendingBalance = async (id, balance) => {
  const response = await api.patch(`/leave-balances/${id}/pending-balance`, balance,
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
  return response.data;
};

// DELETE leave balance
export const deleteLeaveBalance = async (id) => {
  const response = await api.delete(`/leave-balances/${id}`);
  return response.data;
};

export const getAnnualLeaveBalanceByYear = async (id) => {
  const response = await api.get(`/leave-balances/annual/${id}`);
  return response.data;
};